import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Button, Modal } from 'react-bootstrap';
import { translate } from 'react-i18next';
import { capitalize } from 'lodash/string';
import { isEmpty } from 'lodash/lang';

import BookingPhase from '../../components/BookingPhase';
import TimeSlotCard from '../../components/TimeSlotCard';
import PastReservationCard from '../../components/PastReservatioCard';
import { transformReservationsToTimeSlot } from '../../util/helpers';
import AppIcon from '../../components/AppIcon';
import i18n from '../../i18n';
import './history.scss';
import ErrorMessage from '../../components/Messages/ErrorMessage';

class History extends Component {
  constructor(props, context) {
    super(props, context);

    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.fetchPreviousMonth = this.fetchPreviousMonth.bind(this);
    this.groupPastReservations = this.groupPastReservations.bind(this);
    this.adjustInitialMonths = this.adjustInitialMonths.bind(this);
    // including the current month
    this.initialMonthsToFetchInThePast = 3;
    // how many months do we go back in the past
    const monthsAgo = moment().subtract(this.initialMonthsToFetchInThePast - 1, 'months');
    const currentMonth = moment();
    this.state = {
      show: false,
      selectedReservation: null,
      from: monthsAgo.startOf('month'),
      to: currentMonth.endOf('month'),
      pastByMonth: { }
    };
  }

  componentDidMount() {
    const { from } = this.state;
    this.props.getInitialMonths(from.format('YYYY-MM-DD'));
    // this.props.getHistory();
  }

  componentDidUpdate(prevProps) {
    const initialLoadingReady = !prevProps.historyInitialLoaded && this.props.historyInitialLoaded;
    const additionalLoadingReady = !prevProps.historyLoaded && this.props.historyLoaded;
    const reservationsChanged = prevProps.reservations.length !== this.props.reservations.length;

    if (initialLoadingReady) {
      this.adjustInitialMonths();
    }

    if (initialLoadingReady || additionalLoadingReady || reservationsChanged) {
      this.groupPastReservations();
    }

    if (this.props.reservationCancelled) {
      this.handleClose();
    }
  }

  adjustInitialMonths() {
    const { pastByMonth } = this.state;
    for (let monthIndex = 0; monthIndex < this.initialMonthsToFetchInThePast; monthIndex += 1) {
      const monthIterator = moment().subtract(monthIndex, 'months').startOf('month').format('YYYY-MM-DD');
      if (!pastByMonth[monthIterator]) {
        pastByMonth[monthIterator] = [];
      }
    }
    this.setState({ pastByMonth });
  }

  handleClose() {
    this.setState({
      show: false,
      selectedReservation: null
    });
    this.props.closeCancelReservationScreen();
  }

  handleShow(reservation) {
    console.log('reservation', reservation);
    this.setState({
      show: true,
      selectedReservation: reservation
    });
  }

  handleCancel() {
    const { cancelAndRemoveFromReservations } = this.props;
    const { selectedReservation } = this.state;
    cancelAndRemoveFromReservations(selectedReservation.reservation);
  }

  fetchPreviousMonth() {
    const { getPreviousMonth } = this.props;
    const { from, pastByMonth } = this.state;
    const previous = from.subtract(1, 'months');
    const pFrom = previous.clone().startOf('month');
    const pTo = previous.clone().endOf('month');
    getPreviousMonth(pFrom.format('YYYY-MM-DD'), pTo.format('YYYY-MM-DD'));
    pastByMonth[from.format('YYYY-MM-DD')] = []; // needed to show the title of the month

    this.setState({
      from: pFrom,
      to: pTo,
      pastByMonth
    });
  }

  groupPastReservations() {
    const { reservations } = this.props;
    const { pastByMonth } = this.state;
    const now = moment();
    const past = reservations.filter(reservation => this.props.resources[reservation.resource] && this.props.resources[reservation.resource].type === 1 && moment(reservation.start).isBefore(now));
    past.forEach((reservation) => {
      const month = moment(reservation.start).startOf('month').format('YYYY-MM-DD');
      if (!pastByMonth[month]) {
        pastByMonth[month] = [];
      }
      if (pastByMonth[month].filter(r => r.reservation === reservation.reservation).length === 0) {
        pastByMonth[month].push(reservation);
      }
    });
    // update the state
    this.setState({ pastByMonth });
  }

  render() {
    const { reservations, resources, units, cancellingReservationError, t } = this.props;
    const { selectedReservation, pastByMonth } = this.state;
    const now = moment();
    // filter out those with resource type is person (resource.type === 1)
    const upcoming = reservations.filter(reservation => resources[reservation.resource] && resources[reservation.resource].type === 1 && moment(reservation.start).isAfter(now));
    const past = reservations.filter(reservation => resources[reservation.resource] && resources[reservation.resource].type === 1 && moment(reservation.start).isBefore(now));
    const language = i18n.language;

    const upcomingTitle = (
      <div key={'upcoming'} className="upcoming-reservations-title">
        <h3>{t('history.upcoming')}</h3>
      </div>
    );

    const pastTitle = (
      <div key={'past'} className="past-reservations-title">
        <h3>{t('history.past')}</h3>
      </div>
    );

    const cancellationModal = (
      <Modal
        show={this.state.show}
        backdrop="static"
        keyboard={false}
        onHide={this.handleClose}
      >
        <Button
          bsStyle="link"
          className="close-link basic-action-link"
          onClick={this.handleClose}
        >
          <AppIcon iconName="CLOSE" containerClass="close-icon" />
        </Button>
        <Modal.Header>
          <Modal.Title>{t('history.cancelModal.title')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          { selectedReservation &&
          <TimeSlotCard
            timeSlot={transformReservationsToTimeSlot(selectedReservation, resources, t)}
            disabled
            unit={units[selectedReservation.unit]}
            actionElement={<p />}
          />
          }
          <ErrorMessage isVisible={!isEmpty(cancellingReservationError)}>
            <strong>{t('cancelReservation.cancellationFailed')}</strong>
          </ErrorMessage>
          {isEmpty(cancellingReservationError) &&
          <h4>{t('history.cancelModal.confirmText')}</h4>
          }
        </Modal.Body>
        <Modal.Footer>
          {isEmpty(cancellingReservationError) &&
          <Button bsStyle="primary" onClick={this.handleCancel}>{t('history.cancelModal.confirmButton')}</Button>
          }
        </Modal.Footer>
      </Modal>
    );
    console.log(pastByMonth);
    return (
      <div className="history-container">
        <BookingPhase title={t('sectionTitles.history')} id={'history'} />
        <div className="history-items" key={'historyDiv'} >
          { this.props.historyInitialLoaded && upcoming.length === 0 && past.length === 0 &&
          <div className="no-reservation-data">
            <h3>{t('history.noReservationsNorHistory')}</h3>
          </div>
          }
          { upcoming.length > 0 && upcomingTitle }
          {
            upcoming.length > 0 && upcoming
              .sort((a, b) => moment(b.start).valueOf() - moment(a.start).valueOf())
              .map(reservation => (
                <div key={reservation.code} className="upcoming-reservations-container">
                  <TimeSlotCard
                    timeSlot={transformReservationsToTimeSlot(reservation, resources, t)}
                    onClick={() => {
                      if (reservation.canBeCancelled) {
                        this.handleShow(reservation);
                      }
                    }}
                    disabled={!reservation.canBeCancelled}
                    unit={units[reservation.unit]}
                    actionElement={reservation.canBeCancelled ? <span className="time-slot-action-text">{t('cancelReservation.cancelButton')}</span> : <p />}
                  />
                  { !reservation.canBeCancelled &&
                  <span>{t('cancelReservation.notCancelableReason')}</span>
                  }
                </div>
              ))
          }
          { past.length > 0 && pastTitle }
          { Object.keys(pastByMonth)
            .sort((a, b) => moment(b).valueOf() - moment(a).valueOf())
            .map(month => (
              <div key={month} className="past-reservations-container">
                <div key={`${month}-header`} className="month-title">
                  {capitalize(`${moment(month).locale(language).format('MMMM YYYY')} (${pastByMonth[month].length})`)}
                </div>
                {
                  pastByMonth[month].length > 0 && pastByMonth[month]
                    .sort((a, b) => moment(b.start).valueOf() - moment(a.start).valueOf())
                    .map(reservation => (
                      <div key={`${reservation.reservation}`} className="past-reservation-card-container">
                        <PastReservationCard
                          timeSlot={transformReservationsToTimeSlot(reservation, resources, t)}
                          unit={units[reservation.unit]}
                        />
                      </div>
                    ))
                }
              </div>
            )) }
          {}
          <div className="next-month-button-container">
            {this.props.historyInitialLoaded &&
            <Button
              onClick={this.fetchPreviousMonth}
              bsStyle="default"
              bsSize="small"
            >
              <span className="next-month-button-text">{t('history.getMoreButton')}</span>
            </Button>
            }
          </div>
        </div>
        { cancellationModal }
      </div>
    );
  }
}

History.propTypes = {
  historyInitialLoaded: PropTypes.bool.isRequired,
  historyLoaded: PropTypes.bool.isRequired,
  reservations: PropTypes.array.isRequired,
  getInitialMonths: PropTypes.func.isRequired,
  getPreviousMonth: PropTypes.func.isRequired,
  resources: PropTypes.object.isRequired,
  units: PropTypes.object.isRequired,
  cancelAndRemoveFromReservations: PropTypes.func.isRequired,
  cancellingReservationError: PropTypes.string.isRequired,
  reservationCancelled: PropTypes.bool.isRequired,
  closeCancelReservationScreen: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired
};

History.defaultProps = {
  historyInitialLoading: false,
  historyInitialLoaded: false,
  historyLoading: false,
  historyLoaded: false,
  historyPreviousLoaded: false,
  reservations: [],
  resources: {},
  units: {}
};

export default translate(['booking'], { wait: true })(History);



// WEBPACK FOOTER //
// ./src/containers/History/History.jsx